module.exports = __webpack_public_path__ + "static/media/emptystatecontent.8f287050.svg";